import { Component, OnInit, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { OlMapComponent } from '../ol-map/ol-map.component';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';
import * as Proj from 'ol/proj';
import { EstadoPlazaModel } from 'src/app/core/models/estado-plaza.model';
import { environment } from 'src/environments/environment';
import { Overlay } from 'ol';
import { toStringHDMS } from 'ol/coordinate';
import { RegulacionPlazaModel } from 'src/app/core/models/regulacion-plaza.model';
import { PlazaModel } from 'src/app/core/models/plaza.model';

const DEFAULT_LAT = 41.6551800;
const DEFAULT_LON = -4.7237200;
const DEFAULT_ANCHOR = [0.5, 1];

@Component({
  selector: 'ol-map-marker',
  templateUrl: './ol-map-marker.component.html',
  styleUrls: ['./ol-map-marker.component.css']
})
export class OlMapMarkerComponent implements OnInit, OnDestroy {
  @Input() lat: number = DEFAULT_LAT;
  @Input() lon: number = DEFAULT_LON;
  @Input() icon: string ;
  @Input() anchor: number[] = DEFAULT_ANCHOR;
  @Input() plaza?: PlazaModel = new PlazaModel();
  contentPopup: string;
  ICON_GREEN = environment.icon_map.CyD.green;
  ICON_RED = environment.icon_map.CyD.red;
  ICON_BLUE = environment.icon_map.CyD.blue;
  ICON_BLACK = environment.icon_map.CyD.black;
  constructor(private olMap: OlMapComponent) {

   }

  ngOnInit(): void {
    switch (this.plaza.tipoPlaza.id) {
      case 1:
        if (this.plaza.estadoPlaza.id === environment.estados_plaza.DISPONIBLE) {
          this.icon = environment.icon_map.VE.green;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.OCUPADA) {
          this.icon = environment.icon_map.VE.red;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.NO_DISPONIBLE) {
          this.icon = environment.icon_map.VE.black;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.ALARMA_ACTIVA) {
          this.icon = environment.icon_map.VE.blue;
        } else {
          this.icon = environment.icon_map.VE.black;
        }
        break;
      case 2:
        if (this.plaza.estadoPlaza.id === environment.estados_plaza.DISPONIBLE) {
          this.icon = environment.icon_map.PMR.green;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.OCUPADA) {
          this.icon = environment.icon_map.PMR.red;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.NO_DISPONIBLE) {
          this.icon = environment.icon_map.PMR.black;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.ALARMA_ACTIVA) {
          this.icon = environment.icon_map.PMR.blue;
        } else {
          this.icon = environment.icon_map.PMR.black;
        }
        break;
      case 3:
        if (this.plaza.estadoPlaza.id === environment.estados_plaza.DISPONIBLE) {
          this.icon = environment.icon_map.CyD.green;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.OCUPADA) {
          this.icon = environment.icon_map.CyD.red;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.NO_DISPONIBLE) {
          this.icon = environment.icon_map.CyD.black;
        } else if ( this.plaza.estadoPlaza.id === environment.estados_plaza.ALARMA_ACTIVA) {
          this.icon = environment.icon_map.CyD.blue;
        } else {
          this.icon = environment.icon_map.CyD.black;
        }
        break;
      default:
        this.icon = environment.icon_map.CyD.black;
        break;


    }

    const marker = new Feature({
      geometry: new Point(Proj.fromLonLat([this.lon, this.lat])),
      description: 'descripcion del punto',
      calle: this.plaza.direccion,
      ocupacion: this.plaza.estadoPlaza.nombre,
      tipoAparcamiento: this.plaza.tipoAparcamiento,
      tipoPlaza: this.plaza.tipoPlaza,
      coordinate: this.plaza.localizacion.coordinates
    });

    const icon = new Style({
      image: new Icon({
        anchor: this.anchor,
        src: this.icon,
        scale: 0.5
      })
    });

    marker.setStyle(icon);
    const vectorSource = new VectorSource({
        features: [marker]
    });

    vectorSource.on('click', () => {

    });

    const vectorLayer = new VectorLayer({
        source: vectorSource
    });

    if (this.olMap.map) {
      this.olMap.setMarker(vectorLayer);
    } else {
      setTimeout(() => {
        this.ngOnInit();
      }, 10);
    }
  }


  ngOnDestroy() {}

}
